import { Camera } from '../camera';
import { VisionEvent } from './event';

export enum ScanEventType {
  DETECTION = 'detection',
  HISTORY = 'history',
  REBALANCE = 'rebalance',
  DUPLICATE_CONNECTION = 'DuplicateConnection',
  LLM_EVENT = 'llm_event',
}

export enum ScanMode {
  MONITORING = 'monitoroing',
  ESCALATION = 'escalation',
}

export enum CamAction {
  SAFE = 'safe',
  ESCALATE = 'escalate',
  INVESTIGATE = 'investigate',
  RESOLVE_ESCALATION = 'resolve_escalation',
}

export interface GridConfig {
  rows: number;
  cols: number;
}

/**
 * Unified Monitoring's shape for an escalation banner. feature-shared
 * re-exports this rather than keeping its own copy.
 */
export interface EscalationState {
  escalationId: string;
  alarmGroupId: string;
  cameraGroupId?: string;
  tenantId?: string;
  escalationOpenTimestamp: number;
  comment: string;
}

export interface CurrentAndSiblingEscalations {
  currentAlarmEscalation?: EscalationState;
  siblingEscalations?: EscalationState[];
}

export interface CountUpdate {
  camerasInGridCount: number;
  groupsInGridCount: number;
  camerasInQueueCount: number;
  groupInQueueCount: number;
}

export interface CamGroupDetails {
  cameras: Camera[];
  tenantId: string;
  groupName: string;
}

export interface CamLifecycleState {
  enqueuedAt: number;
  shownInGridAt: number; // Timestamp when the camera was shown in the grid
  lastDetectionEvent?: VisionEvent;
}

export interface CameraData {
  camId: string;
  groupId: string;
}

export enum CamFeedMode {
  LIVE = 'live',
  PLAYBACK = 'playback',
  EVENT_VIDEO = 'event_video',
}

export interface LLMEvent {
  alarm_group_id: string;
  camera_group_id: string;
  event_type: string;
  operator_id: string;
  recommendation: string;
  summary: string;
  headline: string;
}
